import { type ReactNode } from 'react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Group, Stack, Text, Title } from '@mantine/core'
import { NotReady, Page, TButton, ThemeButton } from '@components'
import { useAuth0 } from '@auth0/auth0-react'
import { HomePage } from './home/index'

function Index(): ReactNode {
  const { isAuthenticated, isLoading } = useAuth0()

  if (isLoading) return <NotReady isLoading />

  if (isAuthenticated) return <HomePage />

  return <UnauthenticatedPage />
}

const UnauthenticatedPage = (): ReactNode => {
  return (
    <Page>
      <Page.Content>
        <Stack align='center' justify='center' gap='xl' mih='60vh' ta='center'>
          <Stack gap='md' align='center'>
            <Title order={1} size='3rem' fw={700}>
              Welcome to Terros
            </Title>
            <Text size='xl' maw={600} ta='center'>
              Performance tracking and analytics platform for field-based teams. Monitor key metrics, drive results, and
              grow your business with real-time insights.
            </Text>
          </Stack>

          <Group gap='md' justify='center'>
            <TButton component={Link} to='/login' size='md' style={{ minWidth: 140 }}>
              Sign In
            </TButton>
          </Group>

          <Text size='sm' ta='center'>
            Transform your field operations with powerful analytics and mobile-first design
          </Text>
        </Stack>

        <div className='fixed bottom-4 left-4'>
          <ThemeButton />
        </div>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/')({
  component: Index,
})
